export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/about-me.png" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
          I’m a UI/UX Engineer with a Software Engineering degree from NSBM Green University. I started my journey at St. Aloysius College in Galle, where I studied Physical Science at the Advanced Level.
          </p>
          <p className="hero--section-description">
          My diverse academic background, paired with my passion for design, fuels my ability to create impactful and user-centered digital experiences.
          </p>
        </div>
      </div>
    </section>
  );
}
